import { render, staticRenderFns } from "./Captcha.vue?vue&type=template&id=494eb936&scoped=true"
import script from "./Captcha.vue?vue&type=script&lang=ts"
export * from "./Captcha.vue?vue&type=script&lang=ts"
import style0 from "./Captcha.vue?vue&type=style&index=0&id=494eb936&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494eb936",
  null
  
)

export default component.exports